import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-11">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-12">
          <div data-id="element-13">
            <h3 className="text-xl font-bold mb-4" data-id="element-14">UrbanWize</h3>
            <p className="text-gray-300 mb-4" data-id="element-15">
              Kenya's premier host-to-host sharing platform transforming the
              short-term rental market.
            </p>
            <p className="text-emerald-400 font-medium" data-id="element-16">
              Trust. Share. Thrive.
            </p>
          </div>
          <div data-id="element-17">
            <h3 className="text-lg font-semibold mb-4" data-id="element-18">Quick Links</h3>
            <ul className="space-y-2" data-id="element-19">
              <li data-id="element-20">
                <a href="#how-it-works" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-21">
                  How It Works
                </a>
              </li>
              <li data-id="element-22">
                <a href="#features" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-23">
                  Features
                </a>
              </li>
              <li data-id="element-24">
                <a href="#for-hosts" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-25">
                  For Hosts
                </a>
              </li>
              <li data-id="element-26">
                <a href="#for-vendors" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-27">
                  For Vendors
                </a>
              </li>
              <li data-id="element-28">
                <a href="#about" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-29">
                  About Us
                </a>
              </li>
              <li data-id="element-30">
                <a href="#blog" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-31">
                  Blog
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-32">
            <h3 className="text-lg font-semibold mb-4" data-id="element-33">Contact Us</h3>
            <ul className="space-y-2" data-id="element-34">
              <li className="flex items-center" data-id="element-35">
                <PhoneIcon size={16} className="mr-2 text-emerald-400" data-id="element-36" />
                <a href="tel:+254745862148" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-37">
                  +254 745 862 148
                </a>
              </li>
              <li className="flex items-center" data-id="element-38">
                <MailIcon size={16} className="mr-2 text-emerald-400" data-id="element-39" />
                <a href="mailto:urbanwise.solutions@gmail.com" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-40">
                  urbanwise.solutions@gmail.com
                </a>
              </li>
              <li className="flex items-center" data-id="element-41">
                <MapPinIcon size={16} className="mr-2 text-emerald-400" data-id="element-42" />
                <span className="text-gray-300" data-id="element-43">Nairobi, Kenya</span>
              </li>
            </ul>
          </div>
          <div data-id="element-44">
            <h3 className="text-lg font-semibold mb-4" data-id="element-45">Follow Us</h3>
            <div className="flex space-x-4" data-id="element-46">
              <a href="#" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-47">
                <FacebookIcon size={20} data-id="element-48" />
              </a>
              <a href="#" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-49">
                <TwitterIcon size={20} data-id="element-50" />
              </a>
              <a href="#" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-51">
                <InstagramIcon size={20} data-id="element-52" />
              </a>
              <a href="#" className="text-gray-300 hover:text-emerald-400 transition-colors" data-id="element-53">
                <LinkedinIcon size={20} data-id="element-54" />
              </a>
            </div>
            <div className="mt-6" data-id="element-55">
              <h4 className="text-sm font-medium mb-2" data-id="element-56">
                Subscribe to our newsletter
              </h4>
              <div className="flex" data-id="element-57">
                <input type="email" placeholder="Your email" className="px-3 py-2 text-gray-900 bg-gray-100 rounded-l-md focus:outline-none w-full" data-id="element-58" />
                <button className="bg-emerald-600 hover:bg-emerald-700 px-4 py-2 rounded-r-md transition-colors" data-id="element-59">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm" data-id="element-60">
          <p data-id="element-61">
            &copy; {new Date().getFullYear()} UrbanWize. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}